import { FC, ReactNode } from 'react';
import styles from './Texts.module.scss';

interface TextsProps {
  className?: string;
  children: ReactNode;
  boldPhrase?: string;
}

export const Texts: FC<TextsProps> = ({
  className = '',
  children,
  boldPhrase,
}) => {
  if (!boldPhrase) {
    return <p className={`${styles.text} ${className}`}>{children}</p>;
  }

  const text = children?.toString().split(boldPhrase);

  return (
    <p className={`${styles.text} ${className}`}>
      {text?.map((part, index) => {
        if (index !== text.length - 1) {
          return (
            <span key={index}>
              {part}
              <strong className={styles.strong}>{boldPhrase}</strong>
            </span>
          );
        }
        return <span key={index}>{part}</span>;
      })}
    </p>
  );
};
